import "./src/styles/global.css";
import "./src/styles/resets.css";
